import { Typography } from '@mui/material';
import React from 'react';
import { useMainFrameState } from '../MainUIFrame/MainFrame';
import { useDispatch, useSelector } from 'react-redux';
import { quickAddData } from '../../redux/features/quickAddDataSlice';

const NoOptions = props => {
  const { isDark } = useMainFrameState();
  const quickData = useSelector(state => state.quickAddData);
  const reduxDipatch = useDispatch();

  const handleClick = () => {
    reduxDipatch(
      quickAddData({
        ...quickData,
        componentName: props?.name,
      })
    );
  };

  return (
    <>
      <Typography>No options</Typography>
      <Typography
        sx={{
          fontSize: 14,
          color: isDark ? 'white' : 'var(--dark-blue)',
        }}
        onClick={
          props.hasOwnProperty('onClick') && typeof props.onClick === 'function'
            ? () => {
                props.onClick(props?.type);
                handleClick();
              }
            : new Function()
        }
        className="cursor mt-5 fs-sm paragraph-underlined"
      >
        {props?.text || ''}
      </Typography>
    </>
  );
};

export default NoOptions;
